import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { toast } from "react-toastify";
import { getSession } from "../authActions";

export const getProfile = (e) => async (dispatch) => {
  const { token, user_profile_id, role_id, email } = getSession();
  const eemail = e ? e : email;
  dispatch({ type: "profile_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.getProfile}${eemail}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { sys_user_id: user_profile_id, role_id: role_id },
    });
    dispatch({ type: "profile_success", payload: response.data });
    if (!e) {
      profilesaveSession(response.data.usr.rec[0]);
    }
  } catch (error) {
    dispatch({
      type: "profile_failure",
      payload: error?.response?.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

export const updateProfile = (values, id) => async (dispatch) => {
  const { token, user_profile_id } = getSession();

  dispatch({ type: "update_profile_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateProfile}${id ? id : user_profile_id}`,
      values,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "update_profile_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "update_profile_failure",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const profilesaveSession = (dataUser) => {
  sessionStorage.setItem("profileData", JSON.stringify(dataUser));
};
export const getProfileSession = () => {
  const profileDataFromSession = sessionStorage.getItem("profileData");
  const profileData = profileDataFromSession
    ? JSON.parse(profileDataFromSession)
    : null;
  return {
    profileData,
  };
};
export const removeProfile = () => {
  sessionStorage.removeItem("profileData");
};

// USERS ACTIONS
export const userList = (page = 1) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "user_List_req" });
  try {
    const response = await axios.get(`${BaseUrl}${Apis.alluserlist}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { sys_user_id: user_profile_id, role_id: role_id, page: page },
    });

    dispatch({ type: "user_List_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "user_List_failure",
      payload: error.response.data,
    });
    toast.error(error.response.data.usr.message);
  }
};
export const deleteUser = (user_id) => async (dispatch) => {
  const { token, role_id } = getSession();

  dispatch({ type: "user_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateUser}${user_id}`,
      {
        svc_active_yn: "N",
        sys_user_id: user_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "user_delete", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "user_delete_failure",
      payload: error.response.data,
    });
    toast.error(
      `${error.response?.data?.usr?.message ||
      error.response?.data?.message ||
      error.response?.message ||
      error.message
      }`
    );
  }
};

export const createUser = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_user_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newUser}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_user_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_user_failure",
      payload: error.response.data.usr.message,
    });
    toast.error(error.response.data.usr.message);
  }
};

export const editUser = (values, userId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_user_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.userList}${userId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_user_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_user_failure",
      payload: error.response.data,
    });
    // toast.error(error.response.data.usr.message);
  }
};

export const setCurrentUserData = (data) => (dispatch) => {
  dispatch({ type: "set_user_details", payload: data });
};
